import { RewardsReasonCode, SessionMAccountLookupCode } from "./rewards";
import type { Ref } from "vue";

export const LoginPages = {
	"login": 0,
 	"create": 1,
	"forgot-password": 2,
	"select-account": 3,
	"enter-phone": 4,

} as const;

export type LoginPageType = keyof typeof LoginPages;

export type PasswordRequirements = {
	hasMinLength: boolean,
	hasLowercase: boolean,
	hasUppercase: boolean,
	hasNumber: boolean
}

export interface IAuthenticateResource {
	userName: string,
	password: string,
	saveLogin: boolean,
	hasCaptcha: boolean,
	captcha: string,
	skipCartMerge?: boolean
}

export interface IAuthenticateResponse {
	success: boolean,
	captchaFailed?: boolean,
	captchaRequired?: boolean,
	passwordChangeRequired?: boolean,
	redirectUrl?: string,
}

export interface IAuthenticateError {
	success: boolean,
	error: string,
	message: string
	reasonCode?: SessionMAccountLookupCode;
	email?: string;
	phone?: string;
	redactedData?: "phone" | "email" | "both";
}

export interface ICreateAccountResource {
	firstName: string,
	lastName: string,
	emailAddress: string,
	password: string,
	phoneNumber: string,
	saveLogin: boolean,
	skipConnectingRewards: boolean,
	//This will only be true in the scenario where the customer had to choose which
	//sessionM account to connect to, and they selected to connect via their phone
	//instead of email. (See SelectAccountPage.vue)
	hasDesyncedRewards: boolean,
}

export interface ICreateAccountResponse {
	success: boolean,
	reasonCode?: RewardsReasonCode,
	errorMessage?: string,
	email?: string,
	phone?: string,
	headerJson: object,

	//populated when reasonCode == RewardsReasonCode.PHONE_AND_EMAIL_SEPARATE_MATCH
	secondEmail?: string,
	secondPhone?: string,
	redactedData?: "phone" | "email" | "both",
	secondRedactedData?: "phone" | "email" | "both",
}

export interface CreateOauthAccountRequest {
	credentialToken: string,
	loginMethod: LoginMethod,
	phoneNumber: string,
	skipCartMerge: boolean,
}

export interface IRecoveryResource {
	emailAddress: string,
	verificationToken: string
}

export interface IRecoveryResponse {
	success: boolean
}

export interface IGetRewardsDataResponse {
	success: boolean,
	customerHasRewards: boolean,
	sessionMFound: boolean,
	phone: string,
	email: string,
	emailAlreadyLinked: boolean,
}

export type ExternalAuthGoogleOptions = {
	parent: Ref<HTMLElement>,
	options: google.accounts.id.GsiButtonConfiguration
}

export enum LoginMethod {
	Local = "Local",
	Google = "Google",
	Facebook = "Facebook",
	Apple = "Apple"
}
